<template>
  <WellsPrice
    v-if="type === 'wells'"
    :regularPrice="maybeAddTax(regularPrice)"
    :salePrice="maybeAddTax(salePrice)"
    :isVariable="isVariable"
    :showPriceRange="showPriceRange"
  ></WellsPrice>
</template>

<script>
import WellsPrice from '@/components/general-ui/prices/Wells.vue';

export default {
  name: 'Price',
  components: {
    WellsPrice,
  },
  props: {
    regularPrice: Number,
    salePrice: Number,
    isVariable: {
      type: Boolean,
      default() {
        return false;
      }
    },
    showPriceRange: {
      type: Boolean,
      default() {
        return false;
      }
    },
  },
  data() {
    return {
      type: ws_vue_store.config.price,
      includingTax: ws_vue_store.including_tax === '1',
      fixedLength: ws_vue_store.fixed_length,
    };
  },
  computed: {
    removeTax() {
      return !this.$store.getters.getTaxesEnabled;
    }
  },
  methods: {
    maybeAddTax(value) {
      if (Number.isNaN(value) || value === "" || value === undefined) return value;
      if(value === 0) return '';
      if (this.includingTax && this.removeTax) {
        // Remove tax from gross price
        let price = this.formatNumber(parseFloat(value) / ws_vue_store.tax_rate_multiplier);
        if(ws_vue_store.hide_tax_label != '1'){
          price += ' (' + ws_vue_store.translations.excluded_vat + ')';
        }
        return price;
      } else if ( ! this.includingTax && ! this.removeTax) {
        // Add tax to net price
        let price = this.formatNumber(parseFloat(value) * ws_vue_store.tax_rate_multiplier);
        return price;
      }

      return this.formatNumber(value);
    },
    formatNumber(value) {
      return `${value.toFixed(this.fixedLength).toString().replace('.', ',')} €`;
    }
  },
};
</script>
